import ReactPlayer from 'react-player';
import { YouTubeIframe } from './YouTubeIframe';
import './Streamer.scss';
import { VimeoIframe } from './VimeoIframe';
import { ReactPlayerComponent } from './ReactPlayerComponent';

interface StreamerProps {
    link?: string;
    file?: any;
}

export const Streamer = ({ link, file }: StreamerProps) => {    
    const renderIframe = () => {
        if (link.includes('youtube.com')) {
            return<YouTubeIframe link={link} />
        }

        if (link.includes('player.vimeo.com') || link.includes('vimeo.com')) {
            return <VimeoIframe link={link} />;
        }

        return null;
    }

    return <div className="streamer-wrapper">
        {link && renderIframe()}
        {file && !link && <ReactPlayerComponent file={file} />}
    </div>
}